'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-05-02
 *
 */

import timePeriods from './time-periods'

function plugin (Vue) {
	if (plugin.installed) {
		return
	}

	//
	// Adding time periods to Vue object
	//
	Vue.timePeriods = timePeriods
}

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(plugin)
}

export default plugin



// WEBPACK FOOTER //
// ./src/common/index.js